var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1234 4.34659C12.0007 1.50102 7.62379 1.51387 4.39243 4.33725C1.10232 7.21197 1.33354 12.5956 4.30239 15.5152C7.25062 18.4145 12.1253 18.8349 15.8241 15.0075C15.8668 14.9633 15.9379 14.9599 15.9833 15.0014L17.1841 16.1004C17.2519 16.1625 17.3616 16.1217 17.3723 16.0304L17.9992 10.7042C18.0087 10.6238 17.9329 10.5599 17.8552 10.5828L12.7871 12.0778C12.7004 12.1034 12.6775 12.2155 12.7473 12.273L13.9966 13.3029C14.0431 13.3412 14.0509 13.4099 14.014 13.4574C11.9071 16.1685 7.98503 16.0187 5.87811 13.8497C3.74912 11.658 3.64487 8.31414 5.78491 6.2253C7.8774 4.18287 11.0694 3.78937 13.4718 6.00375C13.5629 6.08772 13.7051 6.08818 13.7928 6.00068L15.1291 4.66758C15.2188 4.57819 15.2169 4.43184 15.1234 4.34659Z",
    fill: "url(#paint0_linear_2530_919)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2530_919",
    x1: -0.431958,
    y1: -7.63672,
    x2: 18.5521,
    y2: -7.11893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9DB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.398289cd9b68ae777453e3c594d51c6e.svg";
export { ForwardRef as ReactComponent };